import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate'

import { Flex, Image, Header, P, Box } from 'ui/acro'

const RecommendedItem = forwardRef(({ plan, coachLines, titleLines }, ref) => {
  return (
    <Box ref={ref} className='swiper-slide' width={['158px', '288px']}>
      <Flex
        as='a'
        href={`/series/${plan.slug}`}
        className='unstyled'
        flexDirection='column'
      >
        {plan.coverPhoto && plan.coverPhoto.url && (
          <Image src={plan.coverPhoto.url} />
        )}
        {plan.title && (
          <Header variant='semibold' mt={['6px', '8px', '10px']}>
            <Truncate lines={titleLines}>{plan.title}</Truncate>
          </Header>
        )}
        {plan.coaches && (
          <P color='grey5'>
            <Truncate lines={coachLines}>{plan.coaches}</Truncate>
          </P>
        )}
      </Flex>
    </Box>
  )
})

RecommendedItem.propTypes = {
  coachLines: PropTypes.number,
  plan: PropTypes.object,
  index: PropTypes.number,
  titleLines: PropTypes.number
}

export default RecommendedItem
